import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgCancelXGrey = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="url(#cancelXGrey_svg__a)"
        d="M12 2.854a9.147 9.147 0 1 0 .001 18.293 9.147 9.147 0 0 0 0-18.293"
      />
      <path
        fill="#fff"
        d="M8.714 16.195c-.51 0-.91-.411-.91-.934 0-.237.088-.46.262-.635L10.694 12 8.067 9.374a.9.9 0 0 1-.261-.636c0-.51.398-.909.909-.909.249 0 .448.088.622.25l2.651 2.638 2.676-2.65a.86.86 0 0 1 .622-.262c.498 0 .91.41.91.909 0 .249-.076.46-.262.647L13.294 12l2.627 2.614a.9.9 0 0 1 .262.648c0 .522-.41.933-.921.933a.88.88 0 0 1-.648-.261l-2.627-2.639-2.614 2.639a.92.92 0 0 1-.66.26"
      />
      <defs>
        <linearGradient
          id="cancelXGrey_svg__a"
          x1={3.845}
          x2={20.093}
          y1={3.845}
          y2={20.093}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#bcbcbc" stopOpacity={0.75} />
          <stop offset={1} stopColor="#b0b0b0" />
        </linearGradient>
      </defs>
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgCancelXGrey);
export default Memo;
